function initializeSwipers(backward) {
  let swiperContainers = [];
  if (backward) {
    swiperContainers = document.querySelectorAll('.swiper-container');
  } else {
    swiperContainers = document.querySelectorAll('.swiper-container:not(.swiper-initialized)');
  }

  swiperContainers.forEach((container) => {
    const swiper = new Swiper(container, {
      loop: false,
      freeMode: false,
      allowTouchMove: true,
      shortSwipes: false,
      slideToClickedSlide: true,
      preventClicksPropagation: false,
      preventClicks: false,
      mousewheel: false,
      lazy: true,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChangeTransitionStart: function (event) {
          const slides = container.querySelectorAll('.swiper-slide');
          const nextIndex = event.activeIndex + 1;

          if (nextIndex < slides.length) {
            const originalHref = slides[nextIndex].querySelector('.main-image').getAttribute('data-hide-src');
            slides[nextIndex].querySelector('.main-image').setAttribute('srcset', originalHref);
          }
        },

        slidePrevTransitionStart: function (event) {
          console.log('event', event);
          const slides = container.querySelectorAll('.swiper-slide');
          const nextIndex = event.activeIndex + 2;

          if (event.activeIndex >= 0) {
            if (nextIndex < slides.length) {
              slides[nextIndex].querySelector('.main-image').setAttribute('srcset', '');
            }
          }
        },
        slideChange: function (event) {
          if (swiper.isBeginning) {
            swiper.navigation?.prevEl.classList.add('swiper-button-disabled');
            swiper.navigation?.prevEl.setAttribute('disabled', true);
          } else {
            swiper.navigation?.prevEl.classList.remove('swiper-button-disabled');
            swiper.navigation?.prevEl.removeAttribute('disabled');
          }

          if (swiper.isEnd) {
            swiper.navigation?.nextEl.classList.add('swiper-button-disabled');
            swiper.navigation?.nextEl.setAttribute('disabled', true);
          } else {
            swiper.navigation?.nextEl.classList.remove('swiper-button-disabled');
            swiper.navigation?.nextEl.removeAttribute('disabled');
          }
        },
      },
    });

    const isMobile = window.innerWidth < 989;

    if (isMobile) {
      let startX;
      let isDragging = false;

      const onTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      };

      const onTouchEnd = (e) => {
        if (!isDragging) return;

        const endX = e.changedTouches[0].clientX;
        const diffX = endX - startX;

        if (Math.abs(diffX) > 5) {
          if (diffX > 0) {
            if (swiper.activeIndex > 0) {
              swiper.slideTo(swiper.activeIndex - 1);
            }
          } else {
            if (swiper.activeIndex < swiper.slides.length - 1) {
              swiper.slideTo(swiper.activeIndex + 1);
            }
          }
        }
        isDragging = false;
      };

      swiper.wrapperEl.addEventListener('touchstart', onTouchStart);
      swiper.wrapperEl.addEventListener('touchend', onTouchEnd);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  //initializeSwipers();

  const listContainer = document.getElementById('CollectionPagination');
  if (listContainer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          initializeSwipers();
        }
      });
    });

    observer.observe(listContainer, { childList: true, subtree: false });
  } else {
    initializeSwipers()
  }

  // First animation only on mobile

  const isMobile = window.innerWidth <= 749;

  if (!isMobile) return;

  const grid = document.querySelector('.collection-container')?.querySelector('#product-grid');
  const firstCard = grid?.querySelector('.grid__item');
  const sliderContainer = firstCard?.querySelector('.card__media')?.querySelector('.swiper-container');

  if (!grid || !firstCard || !sliderContainer) return;

  const currentUrl = window.location.href;
  const lastShownUrl = sessionStorage.getItem('lastPLPUrl');

  if (lastShownUrl !== currentUrl) {
    sliderBounceAnimation(sliderContainer);
    sessionStorage.setItem('lastPLPUrl', currentUrl);
  }
});

function sliderBounceAnimation(slider) {
  slider.style.transition = 'transform 0.8s ease';
  slider.style.transform = 'translateX(-25%)';

  setTimeout(() => {
    slider.style.transform = 'translateX(0)';
  }, 800);
}
